/* eslint-disable react-hooks/exhaustive-deps */
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Paper,
    TextField,
    Autocomplete,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHeaderManage from "../PageHeader/PageHeaderManage";
import { t } from "i18next";
import { useFormik } from "formik";
import * as yup from "yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    addManageRefrsh,
    updateManageByIdRefresh,
} from "../../actions/mangeAction";
import { resetSelectedUser, resetState } from "../../slices/manageSlice";
import { showErrorToast } from "../../slices/toastSlice";
import Loader from "../Loader";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// Define exporter schema once and reuse
const exporterSchema = yup.object({
    exportNumber: yup.string().required("exporter Number is required"),
    name: yup.string().required("Name is required"),
    street: yup.string().required("Street is required"),
    city: yup.string().required("City is required"),
    postalCode: yup.string().required("Postal Code is required"),
    province : yup.string().required("Province is required"),
    country: yup.string().required("Country is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    phoneNumber: yup
        .string().required('Phone number is required')
        // .matches(/^\d+$/, 'Phone number must contain only digits')
        .matches(
            /^\+\d{6,14}$/,
            'Phone number is not valid. Please use the format: "+1234567890"'
        ),

});

// Move this to module scope (was inside component)
const initialExporter = {
    exportNumber: "",
    name: "",
    street: "",
    city: "",
    country: "",
    email: "",
    postalCode:"",
    province :"",
    phoneNumber: "",
};

const AddClient = () => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const id = parseInt(searchParams.get("id"));
    const selectedUser = useSelector((state) => state.manage.selectedUser) || {};

    // Build return path to client list preserving original query params (except editing id)
    const listQuery = React.useMemo(() => {
        const qp = new URLSearchParams(searchParams);
        qp.delete('id'); // remove edit id so list doesn't stay in edit context
        return qp.toString();
    }, [searchParams]);
    const listPath = `/client/clientList${listQuery ? `?${listQuery}` : ''}`;


    const { updated, added, hasError, errorMessage, loading } =
        useSelector((state) => state.manage) || {};
    const [exporterExpanded, setExporterExpanded] = useState(false);
    const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);

    const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

    const validationSchema = yup.object().shape({
        userName: yup.string().required("User name is required"),
        name: yup.string().required("First name is required"),
        email: yup.string().nullable().email("Invalid email"),
         ccEmail: yup
            .string()
            .nullable()
            .test(
                "multi-emails",
                "One or more CC emails are invalid",
                (value) => {
                    if (!value) return true; // null أو empty مسموح

                    const emails = value
                        .split(",")
                        .map(e => e.trim())
                        .filter(e => e !== "");

                    if (emails.length === 0) return true;

                    return emails.every(e => isEmail(e));
                }
            ),

        phoneNumber: yup
            .string()
            .nullable()
            .matches(/^\+\d{6,14}$/, 'Phone number is not valid. Please use the format: "+1234567890"'),
        password: yup
            .string()
            .required("Password is required")
            .min(8, "Password must be at least 8 characters long")
            // Backend policy: at least one special !@#$%^&* and only allowed chars
            .matches(/^(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/, "Password must contain at least one special character"),
        // Change WHEN([]) -> LAZY
        exporter: yup.lazy((val) => (val == null ? yup.mixed().nullable() : exporterSchema)),
    });

    const validationSchemaWithoutPassword = yup.object().shape({
        userName: yup.string().required("User name is required"),
        name: yup.string().required("First name is required"),
        email: yup.string().nullable().email("Invalid email"),
        ccEmail: yup
            .string()
            .nullable()
            .test(
                "multi-emails",
                "One or more CC emails are invalid",
                (value) => {
                    if (!value) return true; // null أو empty مسموح

                    const emails = value
                        .split(",")
                        .map(e => e.trim())
                        .filter(e => e !== "");

                    if (emails.length === 0) return true;

                    return emails.every(e => isEmail(e));
                }
            ),

        phoneNumber: yup
            .string()
            .nullable()
            .matches(/^\+\d{6,14}$/, 'Phone number is not valid. Please use the format: "+1234567890"'),
        // Change WHEN([]) -> LAZY
        exporter: yup.lazy((val) => (val == null ? yup.mixed().nullable() : exporterSchema)),
    });

    const activeValidationSchema = React.useMemo(
        () => (!id ? validationSchema : validationSchemaWithoutPassword),
        [id]
    );

    const formik = useFormik({
        initialValues: {
            userName: selectedUser.userName || "",
            name: selectedUser.name || "",
            email: selectedUser.email || null,
            ccEmail: selectedUser.ccEmail ,
            company: selectedUser.company || "",
            phoneNumber: selectedUser.phoneNumber || null,
            password: "",
            enabled: selectedUser.enabled || true,
            dealer: selectedUser.dealer || false,
            exporter: selectedUser.exporter || null

        },
        validationSchema: activeValidationSchema,
        onSubmit: (values) => handleSaveUpdate(values),
        enableReinitialize: true,
    });

    useEffect(() => {
        if (formik.values.exporter != null) {
            setExporterExpanded(true);
        }
    }, [formik.values.exporter]);

    useEffect(() => {
        if (!exporterExpanded && formik.values.exporter != null) {
            setExporterExpanded(true);
        }
    }, [formik.values.exporter, exporterExpanded]);

    // normalize ccEmail for the Autocomplete value (handle array or CSV string)
    const normalizedCcEmails = Array.isArray(formik.values.ccEmail)
        ? formik.values.ccEmail
        : typeof formik.values.ccEmail === "string"
            ? String(formik.values.ccEmail).split(/[;,]+/).map((s) => s.trim()).filter(Boolean)
            : [];

    // If formik somehow contains ccEmail as CSV string (e.g. loaded from backend), convert it to array


    const handleSaveUpdate = (data) => {
        if (data?.email === "") {
            data.email = null;
        }

        // ccEmail is stored as array in the form; convert to comma-separated string for backend
        if (Array.isArray(data?.ccEmail)) {
            if (data.ccEmail.length === 0) {
                data.ccEmail = null;
            } else {
                data.ccEmail = data.ccEmail.join(",");
            }
        } else if (data?.ccEmail === "") {
            data.ccEmail = null;
        }

        if (data?.phoneNumber === "") {
            data.phoneNumber = null;
        }
        const payload = data;




        if (id) {
            dispatch(updateManageByIdRefresh({ mode: "client", id, data: payload }));
            return;
        }
     dispatch(addManageRefrsh({ mode: "client", data: payload }));
    };
    useEffect(() => {
        // eslint-disable-next-line no-mixed-operators
        if (updated || (added && !hasError)) {
            navigate(listPath, {
                state: {
                    updated,
                    added,
                    hasError,
                },
            });
        }

        return () => {
            dispatch(resetState());
            dispatch(resetSelectedUser());
        };
    }, [updated, added, hasError]);
    // Removed unused handleKeyDown (was intercepting Enter key) to satisfy lint.

    if (hasError) {
        dispatch(showErrorToast(errorMessage));
    }
    if (loading === "pending") {
        return <Loader />;
    }

    // Add Exporter: init object and open
    const handleAddExporter = () => {
        if (!formik.values.exporter) {
            formik.setFieldValue("exporter", initialExporter, false);
        }
        setExporterExpanded(true);
    };

    // Ask before closing exporter
    const requestCloseExporter = () => {
        setConfirmCloseOpen(true);
    };

    const confirmCloseExporter = () => {
        // clear exporter back to null and collapse
        formik.setFieldValue("exporter", null, false);
        // clear touched for exporter fields to avoid lingering errors
        ["exportNumber", "name", "street", "city","postalCode","province" ,"country", "email", "phoneNumber"]
            .forEach(f => formik.setFieldTouched(`exporter.${f}`, false, false));
        setExporterExpanded(false);
        setConfirmCloseOpen(false);
    };

    const cancelCloseExporter = () => setConfirmCloseOpen(false);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#F7F8FA",
                py: { xs: 2, md: 4 },
                px: { xs: 1, md: 0 },
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: { xs: "100%", md: "80%", lg: "90%" },
                    mx: "auto",
                    p: { xs: 2, md: 4 },
                    borderRadius: 4,
                    boxShadow: "0 8px 32px 0 rgba(11, 60, 93, 0.10)",
                }}
            >
                <Box sx={{ mb: 3 }}>
                    <PageHeaderManage title={t("client").toUpperCase()} />
                </Box>

                {/* Main Info */}
                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: !id ? "repeat(4, 1fr)" : "repeat(3, 1fr)",
                    }}
                    gap={2}
                    mb={3}
                >
                    <TextField
                        label="User name"
                        name="userName"
                        variant="outlined"
                        value={formik.values.userName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.userName && Boolean(formik.errors.userName)}
                        helperText={formik.touched.userName && formik.errors.userName}
                        fullWidth
                    />
                    <TextField
                        label="Name"
                        variant="outlined"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                        fullWidth
                    />
                    <TextField
                        label="Email"
                        name="email"
                        variant="outlined"
                        value={formik.values.email ?? ""}   // was: formik.values.email
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                        fullWidth
                    />



                    <Autocomplete
                        multiple
                        freeSolo
                        options={[]}
                        value={normalizedCcEmails}
                        onChange={(event, newValue) => {

                       if (Array.isArray(newValue)) {
                            const joined = newValue.map(e => String(e).trim()).filter(Boolean).join(",");
                            formik.setFieldValue("ccEmail", joined);
                        } else {
                            formik.setFieldValue("ccEmail", "");
                        }
                            
                        }}
                        renderTags={(value, getTagProps) =>
                            Array.isArray(value)
                                ? value.map((option, index) => (
                                    <Chip
                                        variant="outlined"
                                        label={option}
                                        {...getTagProps({ index })}
                                        key={option + index}
                                    />
                                ))
                                : null
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("CC Email(s)")}
                                placeholder={t("Type an email and press Enter")}
                                error={formik.touched.ccEmail && Boolean(formik.errors.ccEmail)}
                                helperText={
                                    (formik.touched.ccEmail && formik.errors.ccEmail) ||
                                    t("Enter multiple emails; press Enter to add each")
                                }
                                onBlur={() => formik.setFieldTouched("ccEmail", true)}
                                fullWidth
                            />
                        )}
                    />



                </Box>

                {/* Company Info */}
                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(4, 1fr)",
                    }}
                    gap={2}
                    mb={3}
                >



                    {!id && (
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="password">Password</InputLabel>
                            <OutlinedInput
                                id="password"
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.password && Boolean(formik.errors.password)
                                }
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Password"
                            />
                            <FormHelperText sx={{ color: "red" }}>
                                {formik.touched.password && formik.errors.password}
                            </FormHelperText>
                        </FormControl>
                    )}
                    <TextField
                        label="Company"
                        variant="outlined"
                        name="company"
                        value={formik.values.company}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.company && Boolean(formik.errors.company)}
                        helperText={formik.touched.company && formik.errors.company}
                        fullWidth
                    />
                    <TextField
                        label="Phone Number"
                        variant="outlined"
                        name="phoneNumber"
                        value={formik.values.phoneNumber ?? ""}  // was: formik.values.phoneNumber
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
                        }
                        helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                        fullWidth
                    />


                </Box>



                {/* Company Info */}
                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(5, 1fr)",
                    }}
                    gap={2}
                    mb={3}
                >
                    <FormControlLabel
                        label="Enabled"
                        control={
                            <Checkbox
                                name="enabled"
                                checked={formik.values.enabled ?? true}
                                onChange={formik.handleChange}
                                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                            />
                        }
                        sx={{ alignSelf: "center" }}
                    />


                    <FormControlLabel
                        label="Dealer"
                        control={
                            <Checkbox
                                name="dealer"
                                checked={formik.values.dealer ?? false}
                                onChange={formik.handleChange}
                                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                            />
                        }
                        sx={{ alignSelf: "center" }}
                    />



                </Box>

                {/* Add Exporter action (shown only when not expanded and no exporter set) */}
                {!(exporterExpanded || formik.values.exporter) && (
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
                        <Button
                            startIcon={<AddCircleOutlineIcon />}
                            variant="contained"
                            color="primary"
                            onClick={handleAddExporter}
                        >
                            Add Exporter
                        </Button>
                    </Box>
                )}

                {/* Exporter Section */}
                <Accordion
                    sx={{ mb: 2, borderRadius: 2 }}
                    expanded={formik.values.exporter != null ? true : exporterExpanded}
                    onChange={(e, expanded) => {
                        if (expanded) {
                            // open: ensure exporter exists
                            if (!formik.values.exporter) formik.setFieldValue("exporter", initialExporter, false);
                            setExporterExpanded(true);
                        } else {
                            // attempting to close -> confirm first
                            setExporterExpanded(true); // keep open until confirmed
                            requestCloseExporter();
                        }
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="exporter-content"
                        id="exporter-header"
                        sx={{ bgcolor: "#fff", borderRadius: 2 }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <Box sx={{ fontWeight: 700, fontSize: 18, color: "#0B3C5D", flex: 1 }}>
                                <PageHeaderManage title={t("Exporter").toUpperCase()} />
                            </Box>
                            {(exporterExpanded || formik.values.exporter) && (
                                <Tooltip title={t("Close")}>
                                    <IconButton
                                        aria-label="close exporter"
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            requestCloseExporter();
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Box
                            display="grid"
                            gridTemplateColumns={{
                                xs: "1fr",
                                sm: "repeat(2, 1fr)",
                                md: "repeat(4, 1fr)",
                            }}
                            gap={2}
                        >
                            <TextField
                                label="Exporter Number"
                                name="exporter.exportNumber"
                                variant="outlined"
                                value={formik.values.exporter?.exportNumber || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                                inputProps={{ min: 1 }}
                                error={
                                    formik.touched.exporter?.exportNumber && Boolean(formik.errors.exporter?.exportNumber)
                                }
                                helperText={formik.touched.exporter?.exportNumber && formik.errors.exporter?.exportNumber}

                                fullWidth
                            />

                            <TextField
                                label="Name"
                                name="exporter.name"
                                variant="outlined"
                                value={formik.values.exporter?.name || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                                error={
                                    formik.touched.exporter?.name && Boolean(formik.errors.exporter?.name)
                                }
                                helperText={formik.touched.exporter?.name && formik.errors.exporter?.name}
                                fullWidth
                            />

                            <TextField
                                label="Street"
                                name="exporter.street"
                                variant="outlined"
                                value={formik.values.exporter?.street || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                                error={
                                    formik.touched.exporter?.street && Boolean(formik.errors.exporter?.street)
                                }
                                helperText={formik.touched.exporter?.street && formik.errors.exporter?.street}

                                fullWidth
                            />
                            <TextField
                                label="City"
                                name="exporter.city"
                                variant="outlined"
                                value={formik.values.exporter?.city || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                                error={
                                    formik.touched.exporter?.city && Boolean(formik.errors.exporter?.city)
                                }
                                helperText={formik.touched.exporter?.city && formik.errors.exporter?.city}

                                fullWidth
                            />
 <TextField
                                label="Province"
                                name="exporter.province"
                                variant="outlined"
                                value={formik.values.exporter?.province || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}


                                error={
                                    formik.touched.exporter?.province && Boolean(formik.errors.exporter?.province)
                                }
                                helperText={formik.touched.exporter?.province && formik.errors.exporter?.province}

                                fullWidth
                            />
                            <TextField
                                label="Postal Code"
                                name="exporter.postalCode"
                                variant="outlined"
                                value={formik.values.exporter?.postalCode || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}


                                error={
                                    formik.touched.exporter?.postalCode && Boolean(formik.errors.exporter?.postalCode)
                                }
                                helperText={formik.touched.exporter?.postalCode && formik.errors.exporter?.postalCode}

                                fullWidth
                            />


                           


                            <TextField
                                label="Country"
                                name="exporter.country"
                                variant="outlined"
                                value={formik.values.exporter?.country || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}


                                error={
                                    formik.touched.exporter?.country && Boolean(formik.errors.exporter?.country)
                                }
                                helperText={formik.touched.exporter?.country && formik.errors.exporter?.country}

                                fullWidth
                            />
                            <TextField
                                label="Email"
                                name="exporter.email"
                                variant="outlined"
                                value={formik.values.exporter?.email || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                                error={
                                    formik.touched.exporter?.email && Boolean(formik.errors.exporter?.email)
                                }
                                helperText={formik.touched.exporter?.email && formik.errors.exporter?.email}

                                fullWidth
                            />
                            <TextField
                                label="Phone Number"
                                name="exporter.phoneNumber"
                                variant="outlined"
                                value={formik.values.exporter?.phoneNumber || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                                error={
                                    formik.touched.exporter?.phoneNumber && Boolean(formik.errors.exporter?.phoneNumber)
                                }
                                helperText={formik.touched.exporter?.phoneNumber && formik.errors.exporter?.phoneNumber}

                                fullWidth
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Confirm Close Exporter Dialog */}
                <Dialog
                    open={confirmCloseOpen}
                    onClose={cancelCloseExporter}
                    aria-labelledby="confirm-close-exporter"
                >
                    <DialogTitle id="confirm-close-exporter">
                        {t("Remove Exporter")}
                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                            {t("Are you sure you want to remove the exporter section?")}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={cancelCloseExporter} variant="outlined" color="secondary">
                            {t("Cancel")}
                        </Button>
                        <Button onClick={confirmCloseExporter} variant="contained" color="error">
                            {t("Remove")}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Actions */}
                <Box
                    display="flex"
                    flexDirection={{ xs: "column", sm: "row" }}
                    gap={2}
                    alignItems="center"
                    justifyContent="flex-end"
                    mt={4}
                >
                    <Button
                        variant="outlined"
                        color="secondary"
                        sx={{ minWidth: 120 }}
                        onClick={() => {
                            navigate(listPath);
                            dispatch(resetSelectedUser());
                        }}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: 120 }}
                        onClick={formik.handleSubmit}
                    >
                        {t("Save")}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default AddClient;
